import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fde15faa&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "../../../../styles/scoped.scss?vue&type=style&index=0&id=fde15faa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde15faa",
  null
  
)

export default component.exports